import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const SkylegsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--skylegs']}>
    <Route index element={<Index />} />
  </SubRouter>
))
